import React from 'react';

function AddressBlock(props: any) {
  return (
    <div className="mb-4">
      <p className="terms ps-2 kb-border-start">
        <strong>Current Billing Adddress</strong>
        <br />
        <br />
        872 Beech Street,
        <br />
        Salford
        <br />
        Manchester
        <br />
        M3 8SH
      </p>
    </div>
  );
}
export default AddressBlock;
